<template>
	<div>
		<Tab ref="tab"/>

		<!--<nut-searchbar
			class="search-input"
			v-model="searchValue"
			placeText="搜索中奖人姓名"
			:hasIcon="true"
			:hasSearchButton="false"
			customClass="search"
			@input="inputFun"
			@blur="clearFun"
		></nut-searchbar>-->
		<div class="screening">
			<div class="search-input">
				<nut-icon size="15px" type="search"></nut-icon>
				<input type="text" v-model="username" @keyup.enter="submit" placeholder="请输入中奖人姓名">
				<div @click="clearInput" class="search-input-icon">
					<nut-icon size="15px"  v-if="username" type="circle-cross"></nut-icon>
				</div>
			</div>
		</div>

		<nut-noticebar
			class="noticebar"
			text="可通过微信或个人中心扫一扫进行兑奖"
			:scrollable="false"
		></nut-noticebar>

		<nut-scroller
			class="scroller"
			:is-un-more="isUnMore"
			:is-loading="isLoading"
			:type="'vertical'"
			@loadMore="loadMoreVert"
			@pulldown="pulldown"
		>
			<div slot="list" class="nut-vert-list-panel">
				<template v-if="listData && listData.length">
					<div class="nut-vert-list-item" v-for="(item, index) in listData" :key="index">
					<ul class="nut-scroller-item-info">
						<li class="flex a-center">
							<span class="flex-g-1 flex a-center">
								<b class="name">{{item.wheelname}}</b>
								<span class="tag" v-if="item.state == 1">未兑奖</span>
								<span class="tag disabled" v-else-if="item.state == 2">已兑奖</span>
								<span class="tag disabled" v-else-if="item.state == 3">已过期</span>
								<span class="tag disabled" v-else>未中奖</span>
							</span>
							<nut-button class="button" shape="circle" v-if="item.state == 1" @click="handleClick(item.sn_id)">
								兑奖
							</nut-button>
						</li>
						<li>{{lottstate[item.lottey_state]}}：{{item.prizename}}</li>
						<li v-if="item.is_fake_user !='0'">中奖人：{{item.f_nickname}}</li>
						<li v-else>中奖人：{{item.nickname}}</li>
						<li class="flex j-between">
							<span>联系方式：{{item.lotteymobile}}</span>
							<a :href="'tel://'+item.lotteymobile"><img
									src="../../assets/images/telphone-icon.png"
									width="12"
									height="12"
							/></a>
						</li>
						<li>中奖时间：{{item.wintime|formatItmer}}</li>
					</ul>
				</div>
				</template>
				<empty v-else></empty>
			</div>
		</nut-scroller>

		<nut-dialog
			title="请输入兑奖码"
			:visible="dialogShow"
			@ok-btn-click="handleExchange"
			@cancel-btn-click="closeExchange"
			@close="closeExchange"
		>
			<!-- <a href="javascript:;" @click="dialogShow=false" :noCancelBtn="true">点我可以直接关闭对话框</a> -->
			<nut-textinput
				v-model="value"
				placeholder="请输入内容"
				:clearBtn="true"
				:disabled="false"
			/>
		</nut-dialog>
	</div>
</template>

<script>
import empty from '../Empty'
var timer
export default {
	components:{empty,},

	name: 'exchange-center',
	data: () => ({
		searchValue: '',
		isUnMore: false,
		isLoading: false,
		listData: [],
		lottstate:[],
		page: 1,
		pageSize: 15,//首次15条,以后每次10条
		dialogShow: false,
		username:'',
		type:1,

		value: '', // 兑换码
		sn_id:'',  //奖品snid
	}),
	destroyed() {
		clearTimeout(this.timer)
	},
	created() {
		this.getList();
	},
	methods: {
		getList(){
			this.$ajax.get('m/Activebigwheel/prizecenter', {
				pageIndex: this.page,
				pageSize: this.pageSize,
				activity_id: this.$ajax.get_activity_id(),
				search_name:this.username,
				type:this.type,
			}).then(res => {
				this.isLoading = false;
				if (res.wheeldata && res.wheeldata.length) {
					this.listData = res.wheeldata;
					this.lottstate = res.lottstate;
					//this.listData.push(res.order_list);
					this.isUnMore = false;
					this.pageSize = 10;
					this.page++;
				} else {
					this.isUnMore = true;
				}
			})
		},
		redeem(){
			this.$ajax.post('m/activebigwheel/verfiy_prize', {
				sn:this.value,
				activity_id:this.$ajax.get_activity_id(),
				pid:this.sn_id,
			}).then(res => {
				this.isLoading = true;
				this.dialogShow = false
				this.value = ''
				this.$toast.text('兑奖成功~');
				setTimeout(()=>{
					window.location.reload();
				},2000)
			})
		},
		switchTab(index){
			this.listData = [];
			this.page=1;
			this.pageSize=15;
			this.getList();
		},
		submit() {
			this.listData = [];
			this.page=1;
			this.pageSize=15;
			this.getList();
		},
		clearInput() {
			this.listData = [];
			this.page=1;
			this.pageSize=15;
			this.username = '';
			this.getList();
		},
		// 兑奖
		handleClick(sn_id) {
			this.sn_id = sn_id
			this.dialogShow = true
		},
		handleExchange() {
			if (!this.value) {
				this.$toast.warn('请输入兑奖码')
				return
			}
			this.redeem();
			// this.$toast.text('兑奖成功~')
			// this.dialogShow = false
			// this.value = ''

		},
		closeExchange() {
			this.dialogShow = false
			this.value = ''
		},
		// 下拉加载更多
		pulldown() {
			this.isLoading = true
			this.pageSize = 15;
			this.page = 1;
			this.getList();
		},
		// 上拉加载更多
		loadMoreVert() {
			this.isLoading = true;
			this.getList();
		},
		inputFun(searchValue){
			this.username = searchValue
			this.isLoading = true
			this.pageSize = 15;
			this.page = 1;
			if(timer){
				clearTimeout(timer);
			}
			timer = setTimeout(()=>{
				this.getList();
			},300)
		},
		clearFun(){
			this.username = '';
			this.isLoading = true
			this.pageSize = 15;
			this.page = 1;
			this.getList();
		}
	},
	filters: {
		formatItmer: function (value) {
			value = value+'000';
			let date = new Date(parseInt(value));
			let y = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? ('0' + MM) : MM;
			let d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			let h = date.getHours();
			h = h < 10 ? ('0' + h) : h;
			let m = date.getMinutes();
			m = m < 10 ? ('0' + m) : m;
			let s = date.getSeconds();
			s = s < 10 ? ('0' + s) : s;
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
		}
	},
}
</script>

<style lang="less" scoped>
	.screening {
		width: 100%;
		height: 55px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 10px 15px;
		border-bottom: 1px #E2E2E2 solid;

		.search-input {
			width: 100%;
			height: 30px;
			align-items: center;
			background-color: #f6f6f6;
			border-radius: 20px;
			padding: 0 10px;
			display: flex;
			flex-direction: row;
			justify-content: center;

			input {
				border: none;
				outline: none;
				flex: 1;
				height: 30px;
				background-color: #f6f6f6;
				padding-left: 15px;
				padding-right: 15px;
			}
			.search-input-icon{
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}

.search-input {
	padding: 10px;
}
/deep/ .nut-searchbar .search-input {
	margin-right: 0;
}

.nut-noticebar {
	background: #f1f4ff !important;
	color: #666666 !important;
	font-size: 12px !important;
}
/deep/ .nut-noticebar .left-icon {
	display: none;
}

.scroller {
	height: 75vh;

	.button {
		width: 60px;
		height: 28px;
		padding: 0;
		background: transparent;
		border: 1px solid #3c43ec;
		color: #3c43ec;
	}

	.nut-vert-list-item {
		padding: 10px 14px;
		font-size: 13px;
		color: #666666;
		.name {
			font-size: 15px;
			color: #333333;
		}
		.tag {
			display: inline-block;
			width: 46px;
			height: 20px;
			line-height: 20px;
			background: rgba(252, 232, 234, 1);
			font-size: 11px;
			text-align: center;
			color: #eb273b;
			margin-left: 5px;
			border-radius: 3px;
		}
		.tag.disabled {
			color: #666666;
			background-color: #f0f0f0;
		}
	}
}
</style>
